<template>
  <div class="awards-container">
    <div v-for="(award, index) in awards.slice(0, maxShownAwards)" :key="index">
      <div> 
        <img v-if="!isAnimiatedAward(award.award.image_type)"
        :src="buildAwardURL(award.award.id, award.award.image_type)"
        />

        <lottie-player class="animated" v-if="isAnimiatedAward(award.award.image_type)"
        :src="buildAwardURL(award.award.id, award.award.image_type)" background="transparent" loop autoplay>
        </lottie-player>

      </div>
    </div>
    <div class="awards-text-container">
      <p v-if="getAwardsCount > maxShownAwards">+{{ getAwardsCount - maxShownAwards }} Awards</p>
    </div>
  </div>
</template>


<script>
import {buildAwardURL} from '../../../../helpers/assets.js'; 
export default {
  name: "Awards",
  data(){
    return {
      maxShownAwards: 3,
    } 
  },
  props: {
    awards: {
      type: Array,
    },
  },
  methods:{
    buildAwardURL(awardID, awardType){
      return buildAwardURL(awardID, awardType)
    },
    isAnimiatedAward(awardType) {
      return awardType === 'json' ? true : false;
    },
  },
  computed: {
     getAwardsCount(){
      let totalCount = 0;
      for (let i=0;  i<this.awards.length; i++){
        totalCount += parseInt(this.awards[i].count)
      }
      return totalCount;
    }
  },
};
</script>


<style scoped>
.awards-text-container p { 
  font-size: 1rem;
}
.awards-container{
  /* border: 1px solid red ; */
  display: flex;
  gap: 0.5rem;
  color: white;
  align-items: center;
  justify-content: left;
  padding: 0;
  margin: 0;
}
.awards-container img{
  height: 1.75rem;
}
.awards-container .animated{
  height: 1.75rem;
  width: 2rem;
}
.location-container p {
  font-size: 0.8rem;
  padding: 0;
  margin: 0;
}
</style>